module.exports = __webpack_public_path__ + "img/bearings.7e8dff17.jpeg";